var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"text-left py-3",attrs:{"cols":"12"}},[_c('h4',{staticClass:"border border-left-0 border-top-0 border-right-0 pb-2"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }